export const buildGauge = (percent: number | 'NC', radius: number) => {
  const strokeWidth = radius * 0.2;
  const innerRadius = radius - strokeWidth;
  const circumference = innerRadius * 2 * Math.PI;
  const arc = circumference * 0.5;
  const dashArray = `${arc} ${circumference}`;
  const transform = `rotate(180, ${radius}, ${radius})`;
  const offset = arc - ((percent === 'NC' ? 0 : percent) / 100) * arc;
  const size = radius * 2;
  const text = percent === 'NC' ? '-' : `${Math.round(percent)} %`;

  return `<svg viewBox="0 0 ${size} ${radius}" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="grad">
        <stop stop-color="#4caf50" offset="0%"></stop>
          <stop stop-color="#ffd900" offset="50%"></stop>
          <stop stop-color="#f44336" offset="100%"></stop>
         
        </linearGradient>
      </defs>
      <circle class="gauge_base" cx="${radius}" cy="${radius}" fill="transparent" r="${innerRadius}" stroke="gray" stroke-dasharray="${dashArray}" stroke-linecap="round" stroke-width="${strokeWidth}" transform="${transform}"></circle>
      <circle class="gauge_percent" cx="${radius}" cy="${radius}" fill="transparent" r="${innerRadius}" stroke="url(#grad)" stroke-dasharray="${dashArray}" stroke-dashoffset="${offset}" stroke-linecap="round" stroke-width="${strokeWidth}" transform="${transform}" style="transition: stroke-dashoffset 0.3s ease 0s;"></circle>
      <text x="18" y="30" style="font: bold 14px sans-serif; fill: black;">${text}</text>
    </svg>`;
};
